import styled from 'styled-components';
import { hideOverflowText } from '../../../styles';

import { ColorPicker } from '../../ui-helpers';

export const ContentDescription = styled.div`
  color: ${props => props.theme.colors.white};
`;

export const StyledItem = styled.div`
  height: ${props =>
    props.isEdit
      ? 'auto;'
      : '32px;'};
  border: 1px solid ${props =>
    props.isEdit
      ? props.theme.colors.borderOrange
      : props.theme.colors.borderLightSilver};
  border-radius: ${props =>
    props.isEdit
      ? '5px;'
      : '30px;'};
  padding: 5px;
  display: flex;
  flex-direction: ${props =>
    props.isEdit
      ? 'column;'
      : 'row'};
  align-items: flex-start;
  justify-content: space-between;
`;

export const Title = styled.div`
  color: ${props => props.theme.colors.fontSilverLighter};
  font-size: 18px;
  font-weight: 400;
  padding-bottom: 16px;
`;

export const SectionEditable = styled.input`
  margin-left: 10px;
  width: calc( 100% - 40px);
  font-size: 13px;
  color: ${props => props.theme.colors.fontLightBlack};
  border: none;
  outline: none;

  &::placeholder {
    color: ${props => props.theme.backgroundDarkGray};
  }

  &:focus {
    border-bottom: 1px solid ${props => props.theme.colors.borderLightestSilver};
    margin-bottom: -1px;
  }
`;

export const SectionEditableTop = styled.div`
 display: flex;
 align-items: center;
 justify-content: space-between;
 width: 100%;

 & div {
  display: flex;
 }
`;

export const SectionEditableDescription = styled.div`
  width: 100%;

  & textarea {
    min-height: 25px;
    margin: 10px 0 5px;
    padding: 0;
    font-size: 13px;
    color: #767676;
    border: none;
    outline: 0px !important;
    -webkit-box-shadow: none !important;
    resize: inherit;

    &::placeholder {
      color: #767676;
    }
  }
`;

export const ErrorMessage = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.red};
  margin: 3px 0 0 7px;
`;

export const ItemColor = styled.div`
  padding: 10px;
  background: ${({ color }) => color};
  border-radius: 50%;
  display: inline-block;
`;

export const ColorPickerStyled = styled(ColorPicker)`
  padding: 10px;
  background: ${({ color }) => color};
  border-radius: 50%;
  cursor: pointer;
  
  &+div .twitter-picker div:last-child {
    flex-wrap: wrap;
  }
`;

export const ItemTitle = styled.div`
  display: inline-block;
  margin-left: 10px;
  margin-right: auto;
  ${hideOverflowText};
  max-width: 100px;
  font-size: 13px;
  color: ${props =>
    props.isNew
      ? props.theme.colors.fontSilverLighter
      : props.theme.colors.fontBlack};
  
  &.not-editable {
    max-width: 130px;
  }
`;

export const EditControls = styled.div`
  color: ${props => props.theme.colors.fontSilverLighter};
  margin-right: 5px;
  svg:not(:last-child) {
    margin-right: 10px;
  };
`;

export const EditColorAndTitleWrapper = styled.div`
  min-width: calc( 100% - 45px);
`;



// WEBPACK FOOTER //
// ./src/components/editable-list/listItem/styles.js